// components/modals/orders/DispatchListModal.jsx
import React from "react";
import { Modal, Table, Button, Spinner } from "react-bootstrap";
import CustomPagination from "../../comman/CustomPagination";
import CloseBtn from "../CloseBtn";
import { DEFAULT_PAGE_OPTIONS } from "../../../utils/constants";
import SimpleTable from "../../comman/custom-table/SimpleTable";
import "./../index.css";

const pad2 = (n) => String(n).padStart(2, "0");
const fmtDate = (v) => {
  if (!v) return "—";
  const d = new Date(v);
  if (isNaN(d)) return "—";
  const dd = pad2(d.getDate());
  const mm = pad2(d.getMonth() + 1);
  const yyyy = d.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
};
const fmtDateTime = (v) => {
  if (!v) return "—";
  const d = new Date(v);
  if (isNaN(d)) return "—";
  const dd = pad2(d.getDate());
  const mm = pad2(d.getMonth() + 1);
  const yyyy = d.getFullYear();

  let hh = d.getHours();
  const min = pad2(d.getMinutes());
  const ampm = hh >= 12 ? "pm" : "am";
  hh = hh % 12;
  if (hh === 0) hh = 12;
  return `${dd}/${mm}/${yyyy} ${pad2(hh)}:${min} ${ampm}`;
};
// ---- Address helper ----
const fullAddress = (row) => {
  const parts = [row.address, row.city, row.state, row.pincode].filter(Boolean);
  return parts.join(", ");
};
const ClientListModal = ({ show, onHide, loading = false, list, order }) => {
  console.log("hds", list);
  // debugger;
  const listLength = list?.length;

  const columns = [
    { header: "#", sortable: false, cell: (_v, _r, i) => i + 1, minWidth: 50 },
    { header: "Client Code", accessor: "client_code", sortType: "text" },
    { header: "Name", accessor: "name", sortType: "text" },
    {
      header: "Mobile",
      accessor: "mobile",
      sortType: "text",
      cell: (v) => (v ? <a href={`tel:${v}`}>{v}</a> : "—"),
    },
    {
      header: "Occasion Date",
      accessor: "occassion_date",
      sortType: "date",
      cell: (v) => fmtDate(v),
      minWidth: 140,
    },
    {
      header: "Address",
      sortType: "text",
      className: "small",
      minWidth: 260,
      cell: (_v, row) => fullAddress(row),
    },
    {
      header: "Created At",
      accessor: "created_at",
      sortType: "date",
      cell: (v) => fmtDateTime(v),
      minWidth: 180,
    },
  ];
  return (
    <Modal
      show={show}
      onHide={onHide}
      size={listLength == 0 ? "md" : "xl"}
      centered
    >
      <CloseBtn onClick={onHide} color="#bf352b" />

      <Modal.Header className="">
        <Modal.Title>Order {order}</Modal.Title>
      </Modal.Header>

      <Modal.Body className="overflow-hidden">
        {listLength == 0 ? (
          <h5 className="text-center">no records found</h5>
        ) : (
          <>
            <div className="small text-muted mb-2">
              {/* Showing {list?.length || 0} of {total || 0} records */}
            </div>
            <div className="modal-table-body-cover">
              <div className="h-100">
                <SimpleTable
                  data={list}
                  columns={columns}
                  keyField="id"
                  size="sm"
                  responsive
                  loading={loading}
                  emptyMessage="no records found"
                />
                {/* <CustomPagination
                  currentPage={page}
                  totalPages={totalPages}
                  total={total}
                  pageSize={pageSize}
                  setPageSize={() => {}}
                  className={"sticky-bottom"}
                  setCurrentPage={onPageChange}
                  onPageChange={onPageChange}
                  perPageOptions={DEFAULT_PAGE_OPTIONS}
                /> */}
              </div>
            </div>
          </>
        )}
      </Modal.Body>

      <Modal.Footer className="">
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ClientListModal;
